import { useMutation } from '@vue/apollo-composable';
import gql from 'graphql-tag';
import useAlerts from './useAlerts';

const { addAlert } = useAlerts();

const ADD_QUOTE_MUTATION = gql`
  mutation AddQuoteMutation($quote: TBL_QUOTES_Input) {
    addQuote(quote: $quote)
  }
`;

const UPDATE_QUOTE_MUTATION = gql`
  mutation UpdateQuoteMutation($quoteid: ID!, $quote: TBL_QUOTES_Input) {
    updateQuote(QUOTEID: $quoteid, quote: $quote)
  }
`;

const DELETE_QUOTE_MUTATION = gql`
  mutation DeleteQuoteMutation($quoteid: ID!) {
    deleteQuote(QUOTEID: $quoteid)
  }
`;

const DUPLICATE_QUOTE_MUTATION = gql`
  mutation DuplicateQuoteMutation($quoteid: ID!) {
    duplicateQuote(QUOTEID: $quoteid)
  }
`;

export default function useQuoteMutate() {
  const { mutate: addMutate } = useMutation(ADD_QUOTE_MUTATION);
  const { mutate: updateMutate } = useMutation(UPDATE_QUOTE_MUTATION);
  const { mutate: deleteMutate } = useMutation(DELETE_QUOTE_MUTATION);
  const { mutate: duplicateMutate } = useMutation(DUPLICATE_QUOTE_MUTATION);

  async function addQuote(quote) {
    try {
      const { data } = await addMutate({ quote });
      return data;
    } catch (error) {
      console.error('Error adding quote:', error);
      addAlert('Error adding quote', 'high', 4);
      return null;
    }
  }

  async function updateQuote(quoteid, quote) {
    try {
      const { data } = await updateMutate({ quoteid, quote });
      return data;
    } catch (error) {
      console.error('Error updating quote:', error);
      addAlert('Error updating quote', 'high', 4);
      return null;
    }
  }

  async function deleteQuote(quoteid) {
    try {
      const { data } = await deleteMutate({ quoteid });
      return data;
    } catch (error) {
      console.error('Error deleting quote:', error);
      addAlert('Error deleting quote', 'high', 4);
      return null;
    }
  }

  async function duplicateQuote(quoteid) {
    try {
      const { data } = await duplicateMutate({ quoteid });
      return data;
    } catch (error) {
      console.error('Error duplicating quote:', error);
      addAlert('Error duplicating quote', 'high', 4);
      return null;
    }
  }

  return {
    addQuote,
    updateQuote,
    deleteQuote,
    duplicateQuote,
  };
}
